<aa-popin [isShown]="isShown" [onClose]="closePopin" [width]="26">
  <span class="title">{{'NOTF.TITLE' | translate}}</span>
  <div>
    @if (messages.length !== 0) {
      <div>
        @for (message of messages; track message) {
          <aa-popin-notif-item [message]="message"></aa-popin-notif-item>
        }
      </div>
    } @else {
      <div >
        {{'NOTF.MESSAGE.EMPTY' | translate}}
      </div>
    }
  </div>
</aa-popin>
